fragment ExpertTestimonialFragment on expertTestimonial_Entry {
  typeHandle
}
